import { getDeliveryStatusName } from 'components/ParcelComponent/utils';
import moment from 'moment';
import { returnBaggageType } from '../../models/util';

const getPriceStatus = (status: string, t: any) => {
  switch (status) {
    case 'Proposed': return t('status_proposed');
    case 'Accepted': return t('status_accepted');
    case 'Declined': return t('status_declined');
    default: case 'None': return '-';
  }
}

export const COLUMN = () => [
  {
    name: 'name',
    label: '',
    options: {
      customHeadRender: ({ index }) => (
        <th key={index} style={{ borderBottom: '0px solid rgba(224, 224, 224, 1)' }} />
      )
    }
  },
  {
    name: 'data',
    label: '',
    options: {
      customHeadRender: ({ index }) => (
        <th key={index} style={{ borderBottom: '0px solid rgba(224, 224, 224, 1)' }} />
      ),
      customBodyRender: (
        value: any,
        tableMeta: any,
        updateValue: (arg0: any) => void
      ): JSX.Element => <p>{value}</p>
    }
  }
];

export const createProposalDetail = (
  detail: any,
  baggages: any,
  t: any
): { name: string; data: any }[] => {
  return [
    {
      name: t('title'),
      data: detail.parcelTitle
    },
    {
      name: t('date_of_creation'),
      data: moment(detail.createdOnTS).format('DD.MM.YYYY HH:mm').toString()
    },
    {
      name: t('address_from'),
      data: detail.addressFrom
    },
    {
      name: t('address_to'),
      data: detail.addressTo
    },
    {
      name: t('user_id'),
      data: detail.sender?.id
    },
    {
      name: t('fio_user'),
      data: `${detail?.sender?.firstName ?? ''} ${detail?.sender?.lastName ?? ''} ${detail?.sender?.middleName ?? ''}`
    },
    {
      name: t('number_user'),
      data: detail.sender.phone
    },
    {
      name: t('offer_date'),
      data: moment(detail.departureDateTimeTS).format('DD.MM.YYYY HH:mm').toString()
    },
    {
      name: t('type_baggage'),
      data: detail?.parcelTypes?.map(
        (item: string, index: number) =>
          returnBaggageType(item, baggages, index) +
          (detail.parcelTypes?.length - 1 === index ? '' : ', ')
      )
    },
    {
      name: t('status'),
      data: getDeliveryStatusName(detail.deliveryStatus, t)
    },
    {
      name: t('owner_price'),
      data: `${detail.priceForOwner ?? '-'} ${detail.priceForOwner ? detail.currency : ''}`
    },
    {
      name: t('shifters_price'),
      data: `${detail.priceForShifters ?? '-'} ${detail.priceForShifters ? detail.currency : ''}`
    },
    {
      name: t('recommended_price'),
      data: `${detail.recommendedPrice ?? '-'} ${detail.recommendedPrice ? detail.currency : ''}`
    },
    {
      name: t('recommended_price_status'),
      data: getPriceStatus(detail.recommendedPriceStatus, t)
    }
  ];
};

export const OPTIONS: any = (t: any) => {
  return {
    filter: false,
    responsive: 'vertical',
    draggableColumns: {
      enabled: true
    },
    print: false,
    download: false,
    search: false,
    sort: false,
    viewColumns: false,
    selectableRows: 'none',
    pagination: false,
    textLabels: {
      body: {
        noMatch: t('noMatch'),
        toolTip: t('sort'),
        columnHeaderTooltip: (column: any) => `${t('sort_by')} ${column.label}`
      },
      pagination: {
        next: t('next_page'),
        previous: t('previous'),
        rowsPerPage: t('rowsPerPage'),
        displayRows: t('a_from')
      },
      toolbar: {
        search: t('search'),
        downloadCsv: t('downloadCsv'),
        print: t('print'),
        viewColumns: t('viewColumn'),
        filterTable: t('filterTable')
      },
      filter: {
        all: t('all'),
        title: t('filters'),
        reset: t('reset')
      },
      viewColumns: {
        title: t('showColumns'),
        titleAria: t('show_hide_table_columns')
      },
      selectedRows: {
        text: t('row_selected'),
        delete: t('delete'),
        deleteAria: t('delete_area')
      }
    }
  };
};
